import { Container, Grid, Typography, Card, CardContent } from '@mui/material';
import {
  Package,
  Brain,
  MessageSquare,
  Users,
  TrendingUp,
  Rocket,
  Building2,
  Award
} from 'lucide-react';
import getStyles from './styles';

const KeyBenefitsSection = () => {
  const styles = getStyles();

  const benefits = [
    { icon: Package, text: 'Real product experience' },
    { icon: Brain, text: 'Founder-level exposure' },
    { icon: MessageSquare, text: 'Customer handling & market validation' },
    { icon: Users, text: 'Weekly founder reviews' },
    { icon: TrendingUp, text: '0-to-1 Building Experience' },
    { icon: Rocket, text: 'Leadership & Personal Growth' },
    { icon: Building2, text: 'Opportunity to Become a Co-Founder' },
    {
      icon: Award,
      text: 'Clarity on Your Purpose & Direction'
    }
  ];

  return (
    <Grid sx={styles.section}>
      <Container maxWidth={'xl'}>
        <Grid sx={styles.container}>
          <Typography variant="h2" sx={styles.title}>
            Key Benefits
          </Typography>
          <Typography sx={styles.subtitle}>
            What You&apos;ll Gain from This Fellowship
          </Typography>

          <Grid sx={styles.benefitsGrid}>
            {benefits.map((benefit, idx) => (
              <Card key={idx} sx={styles.benefitCard}>
                <CardContent sx={styles.cardContent}>
                  <Grid sx={styles.iconContainer}>
                    <benefit.icon style={styles.benefitIcon} />
                  </Grid>
                  <Typography sx={styles.benefitText}>
                    {benefit.text}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
};

export default KeyBenefitsSection;
